export const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
export const isAndroid = /Android/i.test(window.navigator.userAgent);
export const isMobile = isIOS || isAndroid;
export const isIE = /MSIE|Trident/.test(window.navigator.userAgent);